const React = require('react');
import EvidenceCardMainContainer from '../evidenceCard.jsx';
import GreySpaceCardMainContainer from '../greySpaceCard.jsx';
const Redirect = require('react-router-dom').Redirect;
const Utils = require('../utils');
const SharedConstants = require('../../../../shared/sharedConstants');

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class CardModal extends React.Component{
   constructor(props) {
      super(props);

      // this modal is self-closing-- 
      // it being open is dependent of having a cModalOpen url parameter
      this.state = {
         closeModal: false,
         refresh: false, 
      }
   }

   render(){
      if (this.state.closeModal) {
         this.setState({ closeModal: false });
         return (
            <Redirect 
               to={{ 
                  pathname: this.props.returnUrl,
                  search: this.props.searchUrl, 
                  state: { refresh: this.state.refresh } 
               }} 
            />
         );
      }

      let cardType = parseInt(Utils.getParameterByName('cardType', window.location.href));
      let idSubmitter = parseInt(Utils.getParameterByName('idSubmitter', window.location.href));

      return(
         <Dialog
            fullWidth
            maxWidth='lg'
            open={!!Utils.getParameterByName('cModalOpen', window.location.href)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            onClose={() => this.setState({ closeModal: true })}
         >
            <DialogTitle className='cardmodal-title'>
               <IconButton 
                  className='x-btn'
                  aria-label='close' 
                  onClick={() => this.setState({ closeModal: true })}
               >
                  <FontAwesomeIcon icon={['far', 'times']} />
               </IconButton>
            </DialogTitle>
            <DialogContent className='cardmodal-content'>
               {cardType === SharedConstants.CardType.Evidence ? (
                  <EvidenceCardMainContainer
                     returnUrl={this.props.returnUrl}
                     currentPortfolio={this.props.currentPortfolio}
                     showComments={this.props.showComments}
                     idSubmitter={idSubmitter}
                     closeFunction={() => this.setState({ 
                        closeModal: true,
                        refresh: true,
                     })}
                  />
               ) : (
                  <GreySpaceCardMainContainer
                     returnUrl={this.props.returnUrl}
                     currentPortfolio={this.props.currentPortfolio}
                     showComments={this.props.showComments}
                     idSubmitter={idSubmitter}
                     closeFunction={() => this.setState({ 
                        closeModal: true,
                        refresh: true,
                     })}
                  />
               )}
            </DialogContent>
         </Dialog>
      )
   }
};